<template>
<div>
  <MainSection titleM="PARTNERI" background="mw20.jpg"/>

  <!-- GODIŠNJI -->
  <div class="partners-main">
    <div class="partners-name">
      <p >GODIŠNJI POKROVITELJI</p>
    </div>
    <div class="partners-logo-container">
      <a href="https://rivian.com/en-GB/">
        <div class="partners-logo"><img src="../assets/partners/godisnji/Rivian_stacked_white_062424.png" style="width:250px"></div>
      </a>
      <a href="https://jetbrains.com/">
        <div class="partners-logo"><img src="../assets/partners/godisnji/jetbrains-mono-white.svg" style="height:80px"></div>
      </a>
      <a href="https://www.yettel.rs/">
        <div class="partners-logo"><img src="../assets/partners/godisnji/Yettel.png" style="height:80px"></div>
      </a>
    </div>

    <!-- GODIŠNJI ROBNI-->
    <div class="partners-name">
      <p >GODIŠNJI ROBNI POKROVITELJI</p>
    </div>
    <div class="partners-logo-container">
      <a href="https://poslovi.infostud.com/">
        <div class="partners-logo"><img src="../assets/partners/godisnji_robni/startuj_white.png" style="width:250px"></div>
      </a>
      <a href="https://www.krojacevaskola.com/">
        <div class="partners-logo"><img src="../assets/partners/godisnji_robni/krojaceva_skola.png" style="width:500px"></div>
      </a>
    </div>

    <!-- MEDIJSKI -->
     <div class="partners-name">
      <p >MEDIJSKI POKROVITELJI</p>
    </div>
    <div class="partners-logo-container">
      <a href="https://www.helloworld.rs/">
        <div class="partners-logo"><img src="../assets/partners/medijski/hello_world.png" style="width:400px"></div>
      </a>
    </div>

    <!-- EDUKATIVNI -->
    <div class="partners-name">
      <p>EDUKATIVNI POKROVITELJI</p>
    </div>
    <div class="partners-logo-container">
      <a href="https://www.etf.bg.ac.rs/">
        <div class="partners-logo"><img src="../assets/partners/edukativni/ETF.png" style="width:150px"></div>
      </a>
    </div>

    <!-- PARTNERSKE ORGANIZACIJE -->
    <div class="partners-name">
      <p>PARTNERSKE ORGANIZACIJE</p>
    </div>
    <div class="partners-logo-container">
      <a href="https://elektron.org.rs/">
        <div class="partners-logo"><img src="../assets/partners/organizacije/elektron.png" style="width:150px"></div>
      </a>
      <a href="https://best.rs/">
        <div class="partners-logo"><img src="../assets/partners/organizacije/BEST.png" style="width:270px"></div>
      </a>
      <div class="partners-logo"><img src="../assets/partners/organizacije/CRKSEF.png" style="width:180px"></div>
    </div>
  </div>
</div>
</template>

<script>


import MainSection from "../components/MainSection.vue"
import Carousel from '@/components/Carousel.vue'

export default {
  name: "Partners",
  components: {
      MainSection,
      Carousel}
}

</script>

<style>


@font-face {
  font-family: "RobotoBlack";
  src: local("fonts"),
   url(../assets/fonts/Roboto-Black.ttf) format("truetype");
}

.partners-main{
  background-color: #FA4952;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 25px;

}

.partners-name{
  display: flex;
  justify-content: center;
  text-align: center;
  font-family: "RobotoBlack", sans-serif;
  line-height: 1.7;
  font-size: 30px;
  font-weight: bolder;
  color:  #990008;
}

.partners-logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.partners-logo {
  margin: 60px;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: 0.25s;
}

.partners-logo:hover {
  transform: scale(1.1);
  transition: 0.25s;
}

img {max-width:100%;}

</style>
